import _typeof from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.delete-property.js";
import "core-js/modules/es.reflect.set.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
export function vm2Api(vmData) {
  return vmData.map(function (item) {
    return {
      name: item.name,
      value: item.componentValue
    };
  });
}
export function getComponentMap(configTools) {
  var componentList = configTools.reduce(function (preVal, curVal) {
    return [].concat(_toConsumableArray(preVal), _toConsumableArray(curVal.componentList));
  }, []);

  // 注册组件结构
  return componentList.reduce(function (preVal, componentItem) {
    preVal[componentItem.platform + componentItem.name] = componentItem;
    return preVal;
  }, {});
}
export function getComponentTemplates(tools) {
  var componentList = tools.reduce(function (preVal, curVal) {
    return [].concat(_toConsumableArray(preVal), _toConsumableArray(curVal.componentList));
  }, []);
  return componentList;
}

// export function api2VmToolItem(configTools, apiData, platform = '') {
//   const componentMap = getComponentMap(configTools, platform);

//   try {

//     const apiJson = apiData === String(apiData) ? JSON.parse(apiData) : apiData;

//     return apiJson.map(({ name, value }) => ({

//       ...componentMap[platform  + name],
//       componentValue: value
//     }));
//   } catch (e) {
//     // 数据解析失败不处理
//     return [];
//   }
// }
export function api2VmToolItem(configTools, configToolsm, apiData) {
  var platform = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var p = localStorage.platform;
  var componentMap1 = getComponentMap(configTools);
  /* debugger */
  var componentMap2 = getComponentMap(configToolsm);

  // const componentMap = [...componentMap1, ...componentMap2]

  var componentMap = {};
  for (var _i = 0, _Object$keys = Object.keys(componentMap1); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    componentMap[key] = componentMap1[key];
  }
  for (var _i2 = 0, _Object$keys2 = Object.keys(componentMap2); _i2 < _Object$keys2.length; _i2++) {
    var _key = _Object$keys2[_i2];
    componentMap[_key] = componentMap2[_key];
  }
  try {
    var apiJson = apiData === String(apiData) ? JSON.parse(apiData) : apiData;
    var arr = [];
    apiJson.forEach(function (_ref) {
      var name = _ref.name,
        value = _ref.value,
        id = _ref.id;
      // location = [1,2] [1] [2]

      /* TODO 不在根据location 判断了 改为根据是tools中的还是toolsm中的 */

      // 1 移动端 2 Pc端
      /* let map = {}
       * if (l === 0){
       *   let p = localStorage.platform
       *   if ( p === 'm') {
       *     map = componentMap[name]
       *   }else {
       *     map = componentMap['PC' + name]
       *   }
       * }else if(l === 1){
       *   map = componentMap[name]
         * }else if(l === 2){
       *   map = componentMap['PC' + name]
       * } */
      /**
      name = Menubar Swiper
      p = m
         */

      /* componentMap1[name]  //pc
       * componentMap2[name]  //m */

      // 
      /* map = componentMap[name] */

      var map = {};
      // p = pc  name = Index Swiper mSwiper pcSwiper  mIndex
      // mIndex 
      map = componentMap[p + name];

      /* map['platform'] = p */

      // map1 map2 map3
      //

      if (!map) {
        var keys = Object.keys(componentMap);
        keys.forEach(function (item) {
          if (item.search(name) != -1) {
            map = componentMap[item];
          }
        });
      }
      arr.push(_objectSpread(_objectSpread({}, map), {}, {
        id: id,
        componentValue: value
      }));
    });
    return arr;
  } catch (e) {
    console.log('e', e);
    // 数据解析失败不处理
    return [];
  }
}

/**
 * 对象、数组变化监听(增删改)
 * @author w-bing
 * @date 2020-04-22
 * @param {Object} obj
 * @param {Function} cb
 * @return {Proxy}
 */
function deepProxy(obj, cb) {
  if (_typeof(obj) === 'object') {
    for (var key in obj) {
      if (_typeof(obj[key]) === 'object') {
        obj[key] = deepProxy(obj[key], cb);
      }
    }
  }
  return new Proxy(obj, {
    /**
     * @param {Object, Array} target 设置值的对象
     * @param {String} key 属性
     * @param {any} value 值
     * @param {Object} receiver this
     */
    set: function set(target, key, value, receiver) {
      if (_typeof(value) === 'object') {
        value = deepProxy(value, cb);
      }
      var cbType = target[key] == undefined ? 'create' : 'modify';

      //排除数组修改length回调
      if (!(Array.isArray(target) && key === 'length')) {
        cb(cbType, {
          target: target,
          key: key,
          value: value
        });
      }
      return Reflect.set(target, key, value, receiver);
    },
    deleteProperty: function deleteProperty(target, key) {
      cb('delete', {
        target: target,
        key: key
      });
      return Reflect.deleteProperty(target, key);
    }
  });
}

// 代理每一个字段
// export function api2VmToolItem(configTools, apiData) {
//   const componentMap = getComponentMap(configTools);
//   try {
//     const apiJson = apiData === String(apiData) ? JSON.parse(apiData) : apiData;
//     return apiJson.map(({ name, value }) => {
//       // let proxy = new Proxy(value, {
//       //   set(target, key, value){

//       //     console.log('value');

//       //     return Reflect.set(target, key, value)
//       //   }
//       // })
//        return {

//         ...componentMap[name],
//         componentValue: deepProxy(value, () => {
//           console.log('value');
//         })
//       }
//     });
//   } catch (e) {
//     // 数据解析失败不处理
//     return [];
//   }
// }
// 初始化配置数据并返回所有组件
export function getComponentsAndInitToolsConfig(configTools) {
  // 平铺开所有组
  var componentList = configTools.reduce(function (preVal, curVal) {
    return [].concat(_toConsumableArray(preVal), _toConsumableArray(curVal.componentList));
  }, []);

  // 注册组件结构
  var data = componentList.reduce(function (preVal, _ref2) {
    var configItemName = _ref2.name,
      platform = _ref2.platform,
      componentPack = _ref2.componentPack;
    // 修改原数据
    // 生成 From组件和View组件 Name
    var needViewName = !componentPack.componentViewName;
    var needFormName = componentPack.Form && !componentPack.componentFormName;

    // 需要生成viewName 或者 formName
    if (needViewName || needFormName) {
      var id = configItemName || genId();
      if (needViewName) componentPack.componentViewName = "".concat(platform, "View").concat(id);
      if (needFormName) componentPack.componentFormName = "".concat(platform, "Form").concat(id);
    }
    if (componentPack.componentFormName) {
      preVal[componentPack.componentFormName] = componentPack.Form;
    }
    preVal[componentPack.componentViewName] = componentPack.View;

    //  PcViewNotice =>
    Object.freeze(componentPack);
    return preVal;
  }, {});

  // 冻结配置数据
  Object.freeze(configTools);
  return data;
}
export function handleHoverColorEnter(context, name, color, i) {
  if (typeof i === 'undefined') {
    if (context.$refs[name].$el) {
      context.oldColor = context.$refs[name].$el.style.color;
      context.$refs[name].$el.style.color = color;
    } else {
      context.oldColor = context.$refs[name].style.color;
      context.$refs[name].style.color = color;
    }
  } else {
    if (context.$refs[name].$el) {
      context.oldColor = context.$refs[name][i].$el.style.color;
      context.$refs[name][i].$el.style.color = color;
    } else {
      context.oldColor = context.$refs[name][i].style.color;
      context.$refs[name][i].style.color = color;
    }
  }
}
export function handleHoverColorLeave(context, name, i) {
  if (typeof i === 'undefined') {
    if (context.$refs[name].$el) {
      context.$refs[name].$el.style.color = context.oldColor;
    } else {
      context.$refs[name].style.color = context.oldColor;
    }
  } else {
    if (context.$refs[name].$el) {
      context.$refs[name][i].$el.style.color = context.oldColor;
    } else {
      context.$refs[name][i].style.color = context.oldColor;
    }
  }
}
export function getURLFileName(url) {
  return url.substring(url.lastINdexOf('/') + 1);
}